<div class="w-full flex-col items-center hidden sm:flex md:m-[0] sm:mt-[2rem]">
  <div class="w-[90%] md:w-[80%]">
    <div class="input-separator">
      <app-text-input (checkForErrors)="checkForErrors($event)"
                      [error]="errorMessages['title']"
                      [parentFormGroup]="addResourceForm"
                      class="resource-input"
                      controlName="title"
                      label="Resource Title"
                      placeholder="Resource Title"
                      type="small"></app-text-input>
    </div>
    <div class="input-separator">
      <app-text-area-input (checkForErrors)="checkForErrors($event)"
                           [error]="errorMessages['description']"
                           [maxLength]="validation.addResources.description.length.max"
                           [parentFormGroup]="addResourceForm"
                           class="resource-input"
                           controlName="description"
                           label="Resource Description"
                           placeholder="Resource Description"
                           showCharCount="true"
                           type="small"></app-text-area-input>
    </div>
    <div class="flex justify-start w-full input-separator">
      <div class="w-[50%]">
        <app-dropdown (checkForErrors)="checkForErrors($event)"
                      [enableMultiple]="true"
                      [error]="errorMessages['sessions']"
                      [label]="'Session'"
                      [loading]="sessionLoading"
                      [options]="sessionDropDownList"
                      [parentFormGroup]="addResourceForm"
                      class="resource-input"
                      controlName="sessions"
                      placeholder="Check all that apply"
                      type="small"/>
        <div *ngFor="let session of addResourceForm.value.sessions"
             class="session-chip inline w-fit">
          {{getSelectedSessionName(session)}}
        </div>
      </div>
      <div class="w-[46%] role-select-wrapper">
        <app-dropdown (checkForErrors)="checkForErrors($event)"
                      [enableMultiple]="true"
                      [error]="errorMessages['roles']"
                      [label]="'Role'"
                      [loading]="rolesLoading"
                      [options]="roleOptions"
                      [parentFormGroup]="addResourceForm"
                      class="resource-input"
                      controlName="roles"
                      placeholder="Check all that apply"
                      type="small"/>
        <div *ngFor="let role of addResourceForm.value.roles"
             class="session-chip inline w-fit">
          {{getSelectedRolesName(role)}}
        </div>
      </div>
    </div>
    <div class="flex justify-start w-full input-separator">
      <div class="w-[50%]">
        <div class="input-label font-work-sans org-group-label">Organization</div>
        <mat-checkbox
          [checked]="allOrganisations"
          (change)="toggleAllOrganisations()"
          class="org-group-checkbox"
        >All Organizations</mat-checkbox>
        <div *ngIf="!allOrganisations" class="mt-[0.5rem]">
          <app-dropdown (checkForErrors)="checkForErrors($event)"
                        [enableMultiple]="true"
                        [error]="errorMessages['organisations']"
                        [loading]="organisationsLoading"
                        [options]="organisationOptions"
                        [parentFormGroup]="addResourceForm"
                        class="resource-input"
                        controlName="organisations"
                        placeholder="Check all that apply"
                        type="small"/>
          <div *ngFor="let org of addResourceForm.value.organisations"
               class="session-chip inline w-fit">
            {{getSelectedOrganisationName(org)}}
          </div>
        </div>
      </div>
      <div class="w-[46%] role-select-wrapper">
        <div class="input-label font-work-sans org-group-label">Group</div>
        <mat-checkbox
          [checked]="allGroups"
          (change)="toggleAllGroups()"
          class="org-group-checkbox"
        >All Groups</mat-checkbox>
        <div *ngIf="!allGroups" class="mt-[0.5rem]">
          <app-dropdown (checkForErrors)="checkForErrors($event)"
                        [enableMultiple]="true"
                        [error]="errorMessages['groups']"
                        [loading]="groupsLoading"
                        [options]="groupOptions"
                        [parentFormGroup]="addResourceForm"
                        class="resource-input"
                        controlName="groups"
                        placeholder="Check all that apply"
                        type="small"/>
          <div *ngFor="let group of addResourceForm.value.groups"
               class="session-chip inline w-fit">
            {{getSelectedGroupName(group)}}
          </div>
        </div>
      </div>
    </div>
    <div class="w-full categories-wrapper">
      <div class="flex flex-col w-full items-center justify-center">
        <div class="w-full">
          <hr class="separator"/>
          <div class="w-full flex">
            <div class="w-[35%] input-label category-separator-heading">
              Category
            </div>
            <div class="w-[35%] input-label category-separator-heading sub-category-column-heading">
              Subcategory
            </div>
            <div class="w-[30%] input-label category-separator-heading action-button-section"
            >
              <div class="add-category-button-wrapper">
                <app-primary-button (handleClick)="addCategories()"
                                    type="small">
                  Add Category
                </app-primary-button>
              </div>
            </div>
          </div>
          <hr class="separator"/>
        </div>
        <div *ngFor="let categories of addResourceForm.value.categories ; let
         index=index"
             class="w-full ">
          <div class="w-full flex categories-list">
            <div class="w-[35%] categories-label category-items">
              {{getSelectedCategoryName(categories.name)}}
            </div>
            <div class="w-[35%] categories-label category-items">
              <ul>
                <li *ngFor="let subcategories of categories.subCategories">
                  {{getSelectedSubCategoryName(categories.name, subcategories)}}
                </li>
              </ul>
            </div>
          </div>
          <hr class="separator"/>
        </div>
      </div>
    </div>
    <div class="w-full categories-wrapper">
      <div class="flex flex-col w-full items-center justify-center">
        <div class="w-full">
          <hr class="separator"/>
          <div class="w-full flex">
            <div class="w-[72%] input-label category-separator-heading ">
              Resources
            </div>
            <div
              class="w-[29%] input-label category-separator-heading action-button-section"
            >
              <div class="add-resource-button-wrapper">
                <app-primary-button (handleClick)="addResources()"
                                    type="small">
                  Add Resources
                </app-primary-button>
              </div>
            </div>
          </div>
          <hr class="separator"/>
        </div>
        <div *ngIf="addResourceForm.value.relatedResources?.length>0"
             class="w-full related-resource-wrapper">
          <table
            [dataSource]="addResourceForm.value.relatedResources"
            class="mat-elevation-z8"
            mat-table
          >
            <ng-container
              matColumnDef="title"
            >
              <th
                *matHeaderCellDef
                class="w-[25%]"
                mat-header-cell
              >
                <div class="th-cell">
                  Resource
                </div>
              </th>
              <td *matCellDef="let eachRow;let index=index"
                  mat-cell>
                <div class="td-cell">
                  <div class="clickable related-resource-content" (click)="openRelatedResource(eachRow)">
                    {{eachRow.title}}
                  </div>
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="category"
            >
              <th
                *matHeaderCellDef
                class="w-[30%]"
                mat-header-cell
              >
                <div class="th-cell resource-categories-title">
                  Categories
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell related-resource-content resource-categories-title">
                  {{getCategoriesName(eachRow.categories)}}
                </div>
              </td>
            </ng-container>
            <ng-container
              matColumnDef="subCategories"
            >
              <th
                *matHeaderCellDef
                class="w-[45%]"
                mat-header-cell
              >
                <div class="th-cell resource-categories-title">
                  Sub Categories
                </div>
              </th>
              <td *matCellDef="let eachRow"
                  mat-cell>
                <div class="td-cell related-resource-content resource-categories-title">
                  {{getSubCategoriesName(eachRow.categories)}}
                </div>
              </td>
            </ng-container>
            <tr *matHeaderRowDef="relatedResourceDisplayColumn"
                mat-header-row></tr>
            <tr *matRowDef="let row; columns: relatedResourceDisplayColumn;"
                mat-row></tr>
          </table>
        </div>
      </div>
    </div>
    <!-- display image section -->
    <div class="image-section-wrapper">
            <span class="label-text input-label image-title">
                Display Image
            </span>
      <div (filesChangeEmitter)="onImageSelection($event)"
           *ngIf="!addResourceForm.value.imageUrl  && !imageLoading"
           appDragDrop
           class="w-full upload-image-section input-separator flex flex-col items-center justify-center">
        <div>
          <app-icon class="upload-icon"
            svgIcon="upload-icon" (click)="heroImage.click()"></app-icon>
        </div>
        <div>
          <div class="label-text text-center w-full upload-image-label drag-drop-label" (click)="heroImage.click()">
            Drag and drop an Image or,
          </div>
          <br>
          <input #heroImage
                 (change)="onImageSelection($event.target.files)"
                 hidden
                 id="file"
                 name="file"
                 type="file"
                 accept="jpeg, jpg, image/jpg, image/png, image/jpeg, png, image/webp, webp"
                >
          <div (click)="heroImage.click()"
               class="find-resources text-center underline w-full font-work-sans font-regular">
            Browse files to Upload
          </div>
        </div>
      </div>
      <!--      image preview-->
      <div *ngIf="addResourceForm.value.imageUrl && !imageLoading"
           class="image-preview-section mt-[1rem]">
        <div class="image-preview-delete-icon">
          <app-icon (click)="deleteSelectedImage()"
                    class="delete-bold-icon cursor-pointer"
                    svgIcon="delete-bold"></app-icon>
        </div>
        <app-image [url]="addResourceForm.value.imageUrl | cdnBaseUrl"
                   alt=""></app-image>
      </div>
      <div *ngIf="imageLoading"
           class="h-full w-full flex justify-center items-center upload-image-section">
        <mat-spinner
          [diameter]="100"
          mode="indeterminate"
          strokeWidth="5"
        />
      </div>
    </div>
  </div>
  <div class="w-full section-separation-wrapper">
    <hr class="section-separator">
  </div>
  <div class="w-[90%] md:w-[80%]">
    <!-- section UI -->
    <div *ngFor="let section of resourceDetails.sections ;let index= index; trackBy: trackBySection"
         class="section-wrapper w-full">
      <app-add-section (deleteSectionEmitter)="sectionDeleteClickHandler($event)"
                       (moveSectionDownEventEmitter)="shiftSectionElementDown($event)"
                       (moveSectionUpEventEmitter)="shiftSectionElementUp($event)"
                       (sectionValueChangeEmitter)="onSectionValueChanges($event)"
                       [currentFormIndex]="index"
                       [sectionData]="section"
                       [totalSectionCount]="resourceDetails?.sections.length"></app-add-section>
    </div>
    <!-- section UI -->
  </div>
  <div *ngIf="resourceDetails?.sections && resourceDetails?.sections.length>0"
       class="w-full section-separation-wrapper">
    <hr class="section-separator w-full">
  </div>
  <div class="w-[90%] md:w-[80%]">
    <div class="flex justify-center w-full">
      <div (click)="addSection()"
           class="cursor-pointer flex items-center add-section-wrapper">
        <app-icon class="add-section-icon"
                  svgIcon="add-bold"></app-icon>
        <span class="ml-[0.8rem] label-text font-work-sans font-semibold">
                Add Section
      </span>
      </div>
    </div>
  </div>
  <div class="action-button-section w-full flex md:justify-end justify-evenly">
    <div class="publish-button min-w-[20%] md:min-w-[15%]">
      <app-primary-button (handleClick)="actionButtonClicked('published')"
                          [isDisabled]="!(resourceDetails.status === 1)"
                          type="small">Publish
      </app-primary-button>
    </div>
    <div class="publish-button preview min-w-[20%] md:min-w-[15%]">
      <app-primary-button (handleClick)="previewButtonClicked()"
                          [isDisabled]="!(resourceDetails.status === 1 ||
                          resourceDetails.status === 2)"
                          type="small">Preview
      </app-primary-button>
    </div>
    <div class="publish-button preview min-w-[20%] md:min-w-[15%]">
      <app-primary-button (handleClick)="actionButtonClicked('draft')"
                          type="small"
                          [isDisabled]="!addResourceForm.value.title || !addResourceForm.value?.['roles']?.length"
      >Save Draft
      </app-primary-button>
    </div>
    <div class="publish-button delete  min-w-[20%] md:min-w-[15%]">
      <app-primary-button (handleClick)="deleteResource()"
                          *ngIf="!(resourceDetails.statusName === 'Published')"
                          [isDisabled]="!(resourceDetails.id)"
                          type="small">
        Delete
      </app-primary-button>
      <app-primary-button (handleClick)="actionButtonClicked('inActive')"
                          *ngIf="(resourceDetails.statusName === 'Published')"
                          [isDisabled]="!(resourceDetails.id)"
                          type="small">
        InActive
      </app-primary-button>
    </div>
    <div class="publish-button delete min-w-[20%] md:min-w-[15%]">
      <app-primary-button (handleClick)="closeEditor()"
                          type="small">Close
        Editor
      </app-primary-button>
    </div>
  </div>
</div>
<div class="flex sm:hidden">
  <app-screen-size-alert [hyperLinkText]="'Go Back To Resources List'"
                         navigationLink="/stanford-admin/resource-hub/resources-list"></app-screen-size-alert>
</div>
